import * as React from "react";

import { Input, type InputProps } from "@/components/ui/input";

interface PriceInputProps extends Omit<InputProps, "value" | "onChange" | "type"> {
  /** Сумма в тийинах (1 сум = 100 тийинов) */
  value: number | null | undefined;
  onChange: (tiyin: number | null) => void;
  currency?: string;
}

/** Input с маской "12 500 000 сум". Хранит и эмитит число в тийинах. */
export function PriceInput({
  value,
  onChange,
  currency = "сум",
  ...rest
}: PriceInputProps): JSX.Element {
  const display = value != null ? formatTiyin(value, currency) : "";

  function handleChange(e: React.ChangeEvent<HTMLInputElement>) {
    const raw = e.target.value.replace(/[^\d]/g, "");
    if (raw === "") {
      onChange(null);
      return;
    }
    const sums = parseInt(raw, 10);
    onChange(sums * 100);
  }

  return (
    <Input
      type="text"
      inputMode="numeric"
      value={display}
      onChange={handleChange}
      {...rest}
    />
  );
}

function formatTiyin(tiyin: number, currency: string): string {
  const sums = Math.floor(tiyin / 100);
  const formatted = sums.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
  return `${formatted} ${currency}`;
}
